<template>
	<v-layout justify-center>
		<v-flex xs12 sm12 md12>
			<v-container>
				<v-row no-gutters>
					<v-col
						v-for="river in Rivers"
						:key="river.title"
						class="align-items-center pa-3"
						block
					>
						<v-btn
							text
							block
							v-on:click="getReport(river)"
							:class="{
								active:
									ReportInfo.River === `The ${river.title}` ||
									ReportInfo.River === river.title,
							}"
						>
							<span class="text-uppercase" text>{{ river.title }}</span>
						</v-btn>
					</v-col>
				</v-row>
				<v-row>
					<rivertemp
						v-bind:ReportInfo="ReportInfo"
						:FlowData="FlowData"
						:imageRef="imageRef"
						:cordinates="cordinates"
						:mapRefs="mapRefs"
						:about="about"
					/>
				</v-row>
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
import fb from "@/fb";
import { Rivers } from "../Models/Rivers";
import rivertemp from "@/components/RRtemplate.vue";
import _ from "lodash";

export default {
	components: {
		rivertemp,
	},
	data() {
		return {
			Rivers: Rivers,
			ReportInfo: {},
			Flows: [],
			Bugs: [],
			riverID: "",
			Sites: [],
			FlowData: [],
			cordinates: { lad: "", long: "" },
			imageRef: "",
			mapRefs: [],
			about: "",
		};
	},
	methods: {
		async getReport(river) {
			this.reset();
			const { Sites, cordinates, imageRef, mapRefs, about, title } = river;

			this.Sites = Sites;
			this.cordinates = cordinates;
			this.imageRef = imageRef;
			this.mapRefs = mapRefs;
			this.about = about;

			const reports = await fb.db.collection("RiverReports").get();
			_.forEach(reports.docs, (report) => {
				const { River } = report.data();
				if (River.match(title)) {
					this.riverID = report.id;
					this.ReportInfo = report.data();
				}
			});

			var getFlow = require("../flows.js");
			var site = "";
			for (site of Sites) {
				const result = await getFlow.initalize(site);
				this.FlowData.push(result.ResultList[0]);
			}
		},
		reset() {
			this.ReportInfo = {};
			this.Flows = [];
			this.Bugs = [];
			this.riverID = "";
			this.Sites = [];
			this.FlowData = [];
			this.cordinates = { lad: "", long: "" };
			this.imageRef = "";
			this.mapRefs = [];
			this.about = "";
		},
	},
	created() {
		const riverMatch = _.find(Rivers, (river) => {
			return this.$route.params.id === river.title;
		});
		const defaultRiver = this.$route.params.id ? riverMatch : Rivers[0];
		this.getReport(defaultRiver);
	},
};
</script>
<style scoped>
.box {
	filter: brightness(100%);
}
.box:hover {
	filter: brightness(50%);
}
a {
	text-decoration: none;
}
.overlayText {
	text-align: center;
	color: white;
}
.active {
	background-color: lightgrey;
}
</style>
